// Replace the values below with your specific Firebase project configuration.
// You can get this from the Firebase Console > Project Settings > General > Your Apps.
export const firebaseConfig = {
  apiKey: "AIzaSyDQhOnY4XsHUREhvaIuFpw7DicdFKrlbeg",
  authDomain: "sport-challenge-2c7af.firebaseapp.com",
  projectId: "sport-challenge-2c7af",
  storageBucket: "sport-challenge-2c7af.firebasestorage.app",
  messagingSenderId: "42391935274",
  appId: "1:42391935274:web:e5520b36645db03e90e653"
};